"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const library_1 = require("@zxing/library");
const BarCodeScanner = ({ onUpdate }) => {
    const codeReader = new library_1.BrowserBarcodeReader();
    react_1.useEffect(() => {
        codeReader.decodeOnceFromVideoDevice(undefined, 'video')
            .then((result) => {
            /* istanbul ignore next */
            onUpdate(null, result);
        }).catch((e) => {
            onUpdate(e, undefined);
        });
        return () => {
            codeReader.reset();
        };
    }, [codeReader]);
    return (react_1.default.createElement("div", { id: "scanner-container" },
        react_1.default.createElement("video", { id: "video", className: "dbrScanner-video", playsInline: true })));
};
exports.default = BarCodeScanner;
